var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "span",
    { staticClass: "position-relative", staticStyle: { height: "1em" } },
    [
      _c("i", { staticClass: "fa fa-link position-absolute" }),
      _vm._v(" "),
      _vm.checked
        ? _c("i", {
            staticClass: "fa fa-check la-icon",
            staticStyle: { color: "var(--green)" }
          })
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }